import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  ViewEncapsulation,
} from '@angular/core';
import { IonMenu } from '@ionic/angular/standalone';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  IconDefinition,
  faCircleChevronLeft,
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'lyceo-ui-more-menu',
  templateUrl: './more-menu.component.html',
  styleUrls: ['./more-menu.component.scss'],
  imports: [IonMenu, FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MoreMenuComponent {
  public contentId: InputSignal<string> = input.required();
  public menuId: InputSignal<string> = input('more-menu');
  public readonly closeMenu: OutputEmitterRef<void> = output();

  protected readonly faCircleChevronLeft: IconDefinition = faCircleChevronLeft;

  @HostBinding('class.lyceo-ui-more-menu')
  public get lyceoUiMoreMenu(): boolean {
    return true;
  }
}
